// TimeZoneContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TimeZoneContextType {
    isNepalTime: boolean;
}

const TimeZoneContext = createContext<TimeZoneContextType | undefined>(undefined);

const TimeZoneProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isNepalTime, setIsNepalTime] = useState<boolean>(false);

    React.useEffect(() => {
        // Function to check if the user's time zone is Nepal Time
        const checkTimeZone = () => {
            const date = new Date();
            const offsetMinutes = date.getTimezoneOffset();
            setIsNepalTime(offsetMinutes === -345);
        };

        checkTimeZone();
    }, [isNepalTime]);

    return (
        <TimeZoneContext.Provider value={{ isNepalTime }}>
            {children}
        </TimeZoneContext.Provider>
    );
};

const useTimeZone = (): TimeZoneContextType => {
    const context = useContext(TimeZoneContext);
    if (context === undefined) {
        throw new Error('useTimeZone must be used within a TimeZoneProvider');
    }
    return context;
};

export { TimeZoneProvider, useTimeZone };
